import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

// Author tools for the book's title page (web.coverpage.html): right-click the title,
// subtitle, contributors or overview while Author Tools is on to edit them. The mount
// div is only rendered for allow_main_author_tools users, so its absence means "off".
export const startCoverpageAuthorTools = coursenum => {
  const rootEl = document.getElementById('coverpage-author-root')
  if (!rootEl) return
  const allowQuill = rootEl.dataset.allowQuill === 'true'
  const root = createRoot(rootEl)
  root.render(<App coursenum={coursenum} allowQuill={allowQuill} />)
}
